(function () {
  'use strict';

  const root = document.querySelector('[data-jm-account]');
  if (!root) return;

  const tabs = Array.from(root.querySelectorAll('[data-account-tab]'));
  const panels = Array.from(root.querySelectorAll('[data-account-panel]'));
  const validTabs = new Set(tabs.map((tab) => tab.dataset.accountTab));

  function activate(name, updateHistory) {
    const selected = validTabs.has(name) ? name : 'inicio';
    tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.accountTab === selected)));
    panels.forEach((panel) => {
      const active = panel.dataset.accountPanel === selected;
      panel.hidden = !active;
      panel.setAttribute('aria-hidden', String(!active));
    });
    if (updateHistory) history.replaceState(null, '', `#${selected}`);
    root.querySelector(`[data-account-panel="${selected}"] h2`)?.focus?.({ preventScroll: true });
  }

  tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab.dataset.accountTab, true)));
  root.querySelectorAll('[data-account-open]').forEach((button) => {
    button.addEventListener('click', () => {
      activate(button.dataset.accountOpen, true);
      root.querySelector('[data-account-panel]:not([hidden])')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
  activate(location.hash.slice(1), false);

  const toast = root.querySelector('[data-account-toast]');
  let toastTimer;
  function notify(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 2600);
  }

  root.querySelectorAll('[data-copy-value]').forEach((button) => {
    button.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(button.dataset.copyValue || '');
        notify('Código de rastreio copiado.');
      } catch (_) {
        notify('Não foi possível copiar automaticamente.');
      }
    });
  });

  const crmTarget = root.querySelector('[data-account-crm]');
  const cashbackTarget = root.querySelector('[data-account-cashback]');
  const cashbackSummary = root.querySelector('[data-account-cashback-summary]');
  if ((!crmTarget && !cashbackTarget && !cashbackSummary) || root.dataset.signedIn !== 'true') return;

  const escapeHtml = (value) => String(value ?? '')
    .replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;').replaceAll("'", '&#039;');
  const money = (cents) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(cents || 0) / 100);
  const date = (value) => value ? new Intl.DateTimeFormat('pt-BR', { dateStyle: 'medium' }).format(new Date(value)) : '';
  const statusLabel = (status) => ({
    converted: 'Compra concluída', abandoned: 'Carrinho abandonado', pending: 'Aguardando pagamento',
    payment_pending: 'Aguardando pagamento', active: 'Em andamento', started: 'Em andamento',
  }[status] || 'Carrinho salvo');
  const cashbackLabel = (type) => ({
    earn_pending: 'Crédito aguardando liberação', release: 'Crédito liberado', reserve: 'Saldo reservado',
    redeem: 'Cashback utilizado', release_reservation: 'Reserva devolvida', expire: 'Crédito expirado',
    reverse: 'Crédito estornado', adjustment: 'Ajuste de carteira',
  }[type] || 'Movimentação de cashback');

  fetch(root.dataset.proxyUrl || '/apps/jm-account', {
    method: 'GET',
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  })
    .then(async (response) => {
      const contentType = response.headers.get('content-type') || '';
      if (!contentType.includes('application/json')) throw new Error('proxy-unavailable');
      const payload = await response.json();
      if (!response.ok || !payload.ok) throw new Error(payload.error || 'portal-unavailable');
      return payload;
    })
    .then((payload) => {
      const cashback = payload.benefits?.cashback || payload.crm?.cashback || {};
      if (cashbackSummary) cashbackSummary.textContent = money(cashback.availableCents || 0);
      if (cashbackTarget) {
        const entries = Array.isArray(cashback.entries) ? cashback.entries : [];
        cashbackTarget.innerHTML = `<div class="jm-account__cashback-head">
          <div><span class="jm-account__cashback-label">Saldo disponível</span><div class="jm-account__cashback-value">${money(cashback.availableCents || 0)}</div><p>Use este valor em suas próximas compras elegíveis.</p></div>
          <div class="jm-account__cashback-status"><span><small>Pendente</small><strong>${money(cashback.pendingCents || 0)}</strong></span><span><small>Reservado</small><strong>${money(cashback.reservedCents || 0)}</strong></span></div>
        </div>${entries.length ? `<div class="jm-account__cashback-history"><h3>Movimentações recentes</h3>${entries.slice(0, 8).map((entry) => `<div><span><strong>${escapeHtml(cashbackLabel(entry.type))}</strong><small>${escapeHtml(date(entry.createdAt))}${entry.expiresAt ? ` · expira ${escapeHtml(date(entry.expiresAt))}` : ''}</small></span><b class="${Number(entry.amountCents || 0) < 0 ? 'is-negative' : ''}">${Number(entry.amountCents || 0) > 0 ? '+' : ''}${money(entry.amountCents || 0)}</b></div>`).join('')}</div>` : '<div class="jm-account__cashback-empty">Sua carteira está ativa. Os créditos aparecerão após o pagamento de compras elegíveis.</div>'}`;
      }
      const carts = Array.isArray(payload.crm?.carts) ? payload.crm.carts : [];
      if (!payload.crm?.synced) {
        if (crmTarget) crmTarget.innerHTML = '<div class="jm-account__empty"><h3>Seu histórico está sendo sincronizado</h3><p>Seus próximos carrinhos e interações aparecerão aqui automaticamente.</p></div>';
        return;
      }
      if (!carts.length) {
        if (crmTarget) crmTarget.innerHTML = '<div class="jm-account__empty"><h3>Nenhum carrinho salvo</h3><p>Quando você iniciar uma compra, o carrinho poderá aparecer aqui para facilitar sua retomada.</p></div>';
        return;
      }
      if (crmTarget) crmTarget.innerHTML = `<div class="jm-account__crm-carts">${carts.map((cart) => {
        const itemCount = (cart.items || []).reduce((total, item) => total + Number(item.quantity || 0), 0);
        return `<article class="jm-account__crm-cart">
          <div class="jm-account__crm-cart-top">
            <div><strong>${escapeHtml(statusLabel(cart.status))}</strong><span> · ${itemCount} ${itemCount === 1 ? 'item' : 'itens'}</span></div>
            <strong>${cart.totalCents == null ? '' : money(cart.totalCents)}</strong>
          </div>
          <span>${escapeHtml(date(cart.updatedAt))}</span>
        </article>`;
      }).join('')}</div>`;
    })
    .catch(() => {
      if (crmTarget) crmTarget.innerHTML = '<p class="jm-account__crm-state">Pedidos e dados da Shopify seguem disponíveis. O histórico de carrinhos será sincronizado em breve.</p>';
      if (cashbackTarget) cashbackTarget.innerHTML = '<p class="jm-account__crm-state">Sua carteira não pôde ser atualizada agora. Tente novamente em instantes.</p>';
    });
})();
